import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';
import '../fragments/recover-inactive-cart-failure.js';
import '../fragments/recover-inactive-cart-result.js';

const REMOVE_CART_LINE_ITEMS = gql`
  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {
    removeCartLineItems(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ... on UnknownCartMutationFailure {
          message
          code
        }
        ... on VoucherCodeNotApplicableFailure {
          cartId
          message
          code
          reason
          voucherCode
        }
      }
      cartMappingFailures {
        ... on ProductNoLongerExistsFailure {
          sku
        }
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { REMOVE_CART_LINE_ITEMS };
//# sourceMappingURL=remove-cart-line-items.js.map
